/**
 * Utility functions for date and time formatting
 */

/**
 * Extract the first name from a full name string
 * Returns the first word, or the full string if it's a single word
 */
export function getFirstName(fullName: string | null | undefined): string {
  if (!fullName || fullName.trim().length === 0) {
    return '';
  }

  const parts = fullName.trim().split(/\s+/);
  return parts[0];
}

/**
 * Format a date and time for display in list rows
 * Example: "Dec 12 | 9:21pm"
 */
export function formatDateTimeForList(
  dateString: string,
  timeString?: string
): string {
  const date = new Date(dateString);
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = date.getDate();

  let timePart = '';
  if (timeString) {
    const time = new Date(timeString);
    timePart = time.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } else {
    // Use the date's time if no separate time string provided
    timePart = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  return `${month} ${day} | ${timePart}`;
}

/**
 * Check if a date string represents a future date
 * Compares the date portion only (ignores time)
 */
export function isDateInFuture(dateString: string): boolean {
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date > today;
}
